<template>
    <div class="consult-container">
        <!-- 批量处理弹框 -->
        <el-dialog :visible.sync="dialogVisible" title="批量处理" width="500px">
            <el-form
                :model="processForm"
                :rules="rules"
                ref="processFormRef"
                label-width="100px"
            >
                <el-form-item label="处理状态" prop="status">
                    <el-radio-group v-model="processForm.status">
                        <el-radio label="1">已处理</el-radio>
                        <el-radio label="0">未处理</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注信息">
                    <el-input
                        v-model="processForm.remark"
                        type="textarea"
                        placeholder="请输入备注信息"
                    />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitBatchProcess"
                        >确定</el-button
                    >
                </span>
            </template>
        </el-dialog>

        <!-- 搜索区域 -->
        <el-card class="search-wrapper">
            <el-form
                :inline="true"
                :model="queryParams"
                class="demo-form-inline"
            >
                <el-form-item label="咨询产品">
                    <el-input
                        v-model="queryParams.product"
                        placeholder="请输入咨询产品"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="提交时间">
                    <el-date-picker
                        v-model="queryParams.submitTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="YYYY-MM-DD"
                    />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select
                        v-model="queryParams.status"
                        placeholder="请选择状态"
                        clearable
                    >
                        <el-option label="未处理" value="0" />
                        <el-option label="已处理" value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery"
                        >查询</el-button
                    >
                    <el-button @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>
            <el-row :gutter="10" class="mb8">
                <el-col :span="1.5">
                    <el-button type="primary" @click="handleBatchProcess"
                        >批量处理</el-button
                    >
                </el-col>
                <el-col :span="1.5">
                    <el-button type="warning" @click="handleExport"
                        >导出</el-button
                    >
                </el-col>
            </el-row>
        </el-card>

        <!-- 表格区域 -->
        <el-card class="table-wrapper">
            <el-table
                v-loading="loading"
                :data="consultList"
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="50" align="center" />
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                />
                <el-table-column label="姓名" prop="name" align="center" />
                <el-table-column label="联系电话" prop="phone" align="center" />
                <el-table-column
                    label="咨询产品"
                    prop="product"
                    align="center"
                />
                <el-table-column
                    label="产品参数"
                    prop="cpCanshu"
                    align="center"
                />
                <el-table-column
                    label="提交时间"
                    prop="submitTime"
                    align="center"
                />
                <el-table-column label="状态" prop="status" align="center">
                    <template #default="scope">
                        <el-tag
                            :type="
                                scope.row.status === '1' ? 'success' : 'info'
                            "
                        >
                            {{ scope.row.status === "1" ? "已处理" : "未处理" }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="备注信息"
                    prop="remark"
                    align="center"
                />
                <el-table-column label="操作" align="center" width="100">
                    <template #default="scope">
                        <el-button
                            type="text"
                            @click="handleProcess(scope.row)"
                        >
                            处理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    v-model:current-page="queryParams.pageNum"
                    v-model:page-size="queryParams.pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "SystemConsult",
    data() {
        return {
            // 遮罩层
            loading: false,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 咨询列表
            consultList: [],
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                product: undefined,
                submitTime: undefined,
                status: undefined,
            },
            // 弹框显示
            dialogVisible: false,
            // 处理表单
            processForm: {
                status: "1",
                remark: "",
            },
            // 表单校验规则
            rules: {
                status: [
                    {
                        required: true,
                        message: "请选择处理状态",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询咨询列表 */
        getList() {
            this.loading = true;
            // TODO: 调用接口获取数据
            // 模拟数据
            setTimeout(() => {
                this.consultList = [
                    {
                        id: 1,
                        name: "张三",
                        phone: "13800138000",
                        product: "NVIDIA A100 GPU",
                        submitTime: "2024-01-05 10:30",
                        status: "0",
                        remark: "",
                    },
                    {
                        id: 2,
                        name: "李四",
                        phone: "13900139000",
                        product: "Intel Xeon CPU",
                        submitTime: "2024-01-05 11:20",
                        status: "1",
                        remark: "已电话沟通",
                    },
                ];
                this.total = 2;
                this.loading = false;
            }, 500);
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                product: undefined,
                submitTime: undefined,
                status: undefined,
            };
            this.handleQuery();
        },
        /** 批量处理按钮操作 */
        handleBatchProcess() {
            if (this.ids.length === 0) {
                this.$message.warning("请选择需要处理的数据");
                return;
            }
            this.dialogVisible = true;
        },

        /** 提交批量处理 */
        submitBatchProcess() {
            this.$refs.processFormRef.validate((valid) => {
                if (valid) {
                    // TODO: 调用批量处理接口
                    this.$message.success("批量处理成功");
                    this.dialogVisible = false;
                    this.getList();
                }
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            // TODO: 实现导出逻辑
            this.$message.success("导出操作");
        },
        /** 表格多选框选中数据 */
        handleSelectionChange(selection) {
            this.ids = selection.map((item) => item.id);
        },
        /** 处理按钮操作 */
        handleProcess(row) {
            // TODO: 实现处理逻辑
            this.dialogVisible = true;
            this.processForm.status = row.status;
            this.processForm.remark = row.remark;
            // this.$message.success(`${row.status === '1' ? '查看' : '处理'}操作：${row.id}`)
        },
        /** 每页显示条数改变 */
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        /** 当前页改变 */
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.consult-container {
    .search-wrapper,
    .operation-wrapper,
    .table-wrapper {
        margin-bottom: 10px;
    }

    .mb8 {
        margin-bottom: 8px;
    }

    .pagination-container {
        margin-top: 20px;
        text-align: right;
    }

    .demo-form-inline {
        display: flex;
    }
}
</style>
